import { createSlice } from "@reduxjs/toolkit";
import { mainFieldManageApiSlice } from "./mainFieldManageApiSlice";

export const initialState = {
  all: {
    data: [],
    totalData: 0,
    page: 1,
    size: 0,
  },
  one: {
    name: "",
    is_active: false,
  },
  query: {},
  fieldOptions: [],
};

export const mainFieldManageSlice = createSlice({
  name: "mainFieldManage",
  initialState,
  reducers: {
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value;
      } else {
        state.query = action.payload;
      }
    },
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    clearOne: (state) => {
      state.one = initialState.one;
    },
    clearQuery: (state) => {
      state.query = initialState.query;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        mainFieldManageApiSlice.endpoints.loadAllFieldData.matchFulfilled,
        (state, { payload }) => {
          state.all = payload;
        }
      )
      .addMatcher(
        mainFieldManageApiSlice.endpoints.loadSingleFiledData.matchFulfilled,
        (state, action) => {
          state.one = action.payload.data;
        }
      );
  },
});

export const { setQueryValue, setOneValue, clearOne, clearQuery } =
  mainFieldManageSlice.actions;

export default mainFieldManageSlice.reducer;
